// we are using classnames to test the select component, because react-select inner components do not pass dataset props to html correctly
export const SELECT_TEST_CLASSNAMES = {
    CHEVRON_ICON: "select-chevron-icon",
    SINGLE_VALUE: "select-single-value",
    REMOVE_VALUE: "select-remove-value",
    CLEAR_FIELD: "select-clear-field"
};
// we are using classnames to test the select component, because react-select inner components do not pass dataset props to html correctly
export const SELECT_TEST_CLASSNAMES = {
    CHEVRON_ICON: "select-chevron-icon",
    SINGLE_VALUE: "select-single-value",
    REMOVE_VALUE: "select-remove-value",
    CLEAR_FIELD: "select-clear-field"
};
